export interface Person {
  id: string;
  sender_id: string;
  state: string;
}

export interface User {
  user_id: string;
  user_fio: string;
}

export interface InvitedPerson extends Person, ParsedInvited {}

export interface InvitedUser extends User {}

export interface ParsedPerson {
  fio: string;
  state: string;
  email: string;
}

export interface ParsedUser {
  fio: string;
  id: string;
}

export interface ParsedInvited {
  email: string;
  invited_fio: string;
}

export enum StatusEnum {
  STATE_CREATED = 'created',
  STATE_ACTIVE = 'active',
  STATE_CANCELLED = 'cancelled',
}

export type DataInvitedPerson = Array<InvitedPerson>;
export type DataParsedPerson = Array<ParsedPerson>;
export type DataInvitedUser = Array<InvitedUser>;
export type DataParsedUser = Array<ParsedUser>;
export type PromiseDataParsedPerson = { data: DataParsedPerson };
export type PromiseParsedInvited = { data: ParsedInvited };



// WEBPACK FOOTER //
// ./src/services/invite/utils/types.ts